import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { supabase } from "../../lib/supabase";
import "./Gallery.css";

const DEFAULT_GALLERIES = [
  { key: "gallery_1", name: "Dara Art Gallery", name_ar: "معرض دارا للفنون", img: "https://500wordsmag.com/wp-content/uploads/2021/09/Dara-Art-Gallery-1024x377.jpg", url: "https://daraartgallery.com", instagram: "@daraartgallery", contact: null, tag: "Contemporary", tag_ar: "معاصر", desc: "Established in 1999 by Rashid Diab and Mercedes Carmona, Dara Art Gallery hosts exhibitions of Sudanese art and contemporary African art by masters such as Ibrahim El-Salahi and Ahmad Shibrain.", desc_ar: "تأسس عام 1999 على يد رشيد دياب ومرسيدس كارمونا، يستضيف معرض دارا للفنون معارض للفن السوداني والفن الأفريقي المعاصر من أعمال أساتذة كإبراهيم الصلحي وأحمد شبرين." },
  { key: "gallery_2", name: "Mojo Gallery", name_ar: "معرض موجو", img: "https://500wordsmag.com/wp-content/uploads/2021/08/Mojo-Gallery-1.jpg", contact: "+249 912 905 846", email: "mojo.galery@gmail.com", instagram: "@mojogallery", tag: "Interactive", tag_ar: "تفاعلي", desc: "Established in 2010, Mojo Gallery is an interactive place for people with an elite artistic taste, where they come together to share their love and admiration for art.", desc_ar: "تأسس عام 2010، معرض موجو مكان تفاعلي لمحبي الفنون الراقية، يلتقون فيه ليتشاركوا عشقهم وإعجابهم بالفن." },
  { key: "gallery_3", name: "The Downtown Gallery", name_ar: "معرض داون تاون", img: "https://500wordsmag.com/wp-content/uploads/2022/03/The-Downtown-Gallery-1024x761.jpg", url: "https://sudandowntowngallery.wordpress.com", instagram: "@sol.downtown.gallery", contact: "+249 99 479 9526", tag: "Curation", tag_ar: "تنسيق", desc: '"The Hidden Gem of Alsoog Alarabi." The gallery is transforming the concept of art curation in Sudan.', desc_ar: '"الجوهرة المخفية لسوق العربي." يُعيد المعرض تعريف مفهوم تنسيق الفنون في السودان بجداريات تتسع لـ18 عملاً فنياً.' },
  { key: "gallery_4", name: "Remenar Gallery", name_ar: "معرض رمينار", img: "https://500wordsmag.com/wp-content/uploads/2021/08/Remenar-Gallery.jpg", contact: "+249 91 607 1017", email: "sogdan@gmail.com", tag: "Heritage", tag_ar: "تراث", desc: "A contemporary and visual art gallery where you can view and shop for original paintings, heritage pieces, various handicrafts, and antiques.", desc_ar: "صالة فنون معاصرة وبصرية حيث يمكنك مشاهدة وشراء اللوحات الأصيلة وقطع التراث والمشغولات اليدوية والتحف." },
];

const DEFAULT_SPACES = [
  { key: "space_1", name: "Dabanga Shop", name_ar: "متجر دبنقا", img: "https://500wordsmag.com/wp-content/uploads/2021/08/Dabanga-Shop.jpg", credit: "Paul Kroopkin", desc: "A souvenir shop offering unique handcrafts, artwork and creative work from Sudan and Africa. View and purchase paintings, sculptures, jewelry, and furniture.", desc_ar: "متجر تذكارات يقدم مشغولات يدوية فريدة وأعمالاً فنية وإبداعية من السودان وأفريقيا. استعرض واقتنِ لوحات ومنحوتات ومجوهرات وأثاثاً." },
  { key: "space_2", name: "Papa Costa Restaurant", name_ar: "مطعم بابا كوستا", img: "https://500wordsmag.com/wp-content/uploads/2021/08/Papa-Costa-Gallery-Daniel-Weiss.jpg", credit: "Daniel Weiss", desc: "One of the oldest restaurants in Sudan. Known for hosting some of the best music concerts and art exhibitions in town.", desc_ar: "أحد أقدم المطاعم في السودان. يشتهر باستضافة بعض أفضل الحفلات الموسيقية والمعارض الفنية في المدينة." },
  { key: "space_3", name: "Someet Gallery & Café", name_ar: "صالة وكافيه سوميت", img: "https://500wordsmag.com/wp-content/uploads/2021/08/Someet-Gallery-1024x461.jpg", credit: "The gallery", contact: "+249 92 822 1015", email: "someetgallery@gmail.com", instagram: "@someet_gallery", desc: "A small, intimate and colourful café where you enjoy casual and cultural dining whilst looking at art, antiques, handcrafts and furniture.", desc_ar: "مقهى صغير ودافئ وملوّن تستمتع فيه بالطعام الثقافي غير الرسمي بينما تتأمل الفنون والتحف والمشغولات اليدوية والأثاث." },
];

const DEFAULT_ARTISTS = [
  { key: "artist_1", name: "Ibrahim El-Salahi", name_ar: "إبراهيم الصلحي", tag: "Born 1930, Sudan", tag_ar: "مواليد 1930، السودان", img: "https://media.tate.org.uk/art/images/work/T/T13/T13979_10.jpg", desc: "One of the most important living African artists and a key figure in the development of African Modernism. El-Salahi grew up in Omdurman and studied at the Slade School in London.", desc_ar: "أحد أهم الفنانين الأفارقة الأحياء وشخصية محورية في تطور الحداثة الأفريقية. نشأ في أمدرمان ودرس في مدرسة سلاد في لندن.", url: "https://www.tate.org.uk/art/artists/ibrahim-el-salahi-8294" },
  { key: "artist_2", name: "Hassan Musa", name_ar: "حسن موسى", tag: "Active globally", tag_ar: "نشط عالمياً", img: "https://hassanmusaofficial.com/wp-content/uploads/2019/03/ak-leda-1.jpg", desc: '"An image, deep down, is like a bottle thrown into the sea." Musa\'s innovative approach revitalizes Sudanese art by merging local tradition with global commentary.', desc_ar: '"الصورة في أعماقها كزجاجة ترمى في البحر." يُجدد موسى الفن السوداني بدمجه التراث المحلي مع التعليق العالمي.', url: "https://hassanmusaofficial.com/" },
  { key: "artist_3", name: "Noman Faris", name_ar: "نعمان فارس", tag: "1966 – 2007", tag_ar: "1966 – 2007", img: "https://pbs.twimg.com/media/DziBweQXgAIXUOD?format=jpg&name=small", desc: "Born in central Sudan in 1966, Noman Faris passed in Cairo on October 31, 2007. He graduated in 1992 from the Printing & Bookbinding department, College of Fine & Applied Art, Khartoum.", desc_ar: "وُلد في وسط السودان عام 1966، وتوفي نعمان فارس في القاهرة في 31 أكتوبر 2007. تخرج عام 1992 من قسم الطباعة والتجليد بكلية الفنون الجميلة والتطبيقية في الخرطوم.", url: "/ArtistsList" },
];

const DEFAULT_LINKS = [
  { name: "IBRAAZ Platform", name_ar: "منصة إبراز", url: "https://www.ibraaz.org/", desc: "Where to Now? Shifting Regional Dynamics and Cultural Production in North Africa and the Middle East.", desc_ar: "إلى أين الآن؟ الديناميكيات الإقليمية المتحولة والإنتاج الثقافي في شمال أفريقيا والشرق الأوسط." },
  { name: "Canvas Magazine", name_ar: "مجلة كانفاس", url: "https://canvasonline.com/", desc: "A bi-yearly publication covering cultural growth across Saudi Arabia, UAE, Qatar and the GCC and MEA region.", desc_ar: "مطبوعة نصف سنوية تغطي النمو الثقافي في المملكة العربية السعودية والإمارات وقطر ومنطقة الخليج والشرق الأوسط." },
  { name: "Art Dubai", name_ar: "آرت دبي", url: "https://www.artdubai.ae/", desc: "The Middle East's leading international art fair, taking place every March in Dubai, UAE.", desc_ar: "معرض الفن الدولي الرائد في الشرق الأوسط، يُقام كل مارس في دبي، الإمارات العربية المتحدة." },
  { name: "Sponsor a Sudanese Artist", name_ar: "ادعم فناناً سودانياً", url: "https://sponsorasudaneseartist.wordpress.com/meet-the-artists/", desc: "Join the campaign and support Sudanese artists displaced by war.", desc_ar: "انضم إلى الحملة وادعم الفنانين السودانيين المهجّرين بسبب الحرب." },
];

const STREET_IMG = "https://www.albawaba.com/sites/default/files/im_new/ewelina/000_1FW1G5.jpg";

function Lightbox({ src, onClose }) {
  useEffect(() => {
    const h = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClose]);
  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.92)",
      display: "flex", alignItems: "center", justifyContent: "center", cursor: "zoom-out",
    }}>
      <img src={src} alt="" style={{ maxWidth: "92vw", maxHeight: "92vh", borderRadius: 8, objectFit: "contain" }} />
      <button onClick={onClose} style={{ position: "absolute", top: 20, right: 24, background: "none", border: "none", color: "#fff", fontSize: 28, cursor: "pointer" }}>✕</button>
    </div>
  );
}

function ImgWithFallback({ src, alt, className, style, fallbackText, onClick }) {
  const [err, setErr] = useState(false);
  if (err) return (
    <div className={className} style={{ ...style, display: "flex", alignItems: "center", justifyContent: "center", background: "#1a1a1a", color: "#444", fontSize: 20 }}>
      {fallbackText}
    </div>
  );
  return <img src={src} alt={alt} className={className} style={{ ...style, cursor: onClick ? "zoom-in" : "default" }} onClick={onClick} onError={() => setErr(true)} />;
}

export default function Gallery() {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === "ar" || i18n.language?.startsWith("ar");
  const [cms,      setCms]      = useState({});
  const [lightbox, setLightbox] = useState(null);
  const openLb = useCallback((src) => setLightbox(src), []);

  useEffect(() => {
    supabase
      .from("page_sections")
      .select("*")
      .eq("page", "gallery")
      .eq("is_visible", true)
      .order("sort_order", { ascending: true })
      .then(({ data }) => {
        if (data) {
          const map = {};
          data.forEach((s) => { map[s.section_key] = s; });
          setCms(map);
        }
      });
  }, []);

  const cTitle = (key, defEn, defAr) => {
    const s = cms[key];
    if (!s) return isAr ? (defAr || defEn) : defEn;
    return isAr ? (s.title_ar || s.title_en || defAr || defEn) : (s.title_en || s.title_ar || defEn);
  };
  const cBody = (key, defEn, defAr) => {
    const s = cms[key];
    if (!s) return isAr ? (defAr || defEn) : defEn;
    return isAr ? (s.body_ar || s.body_en || defAr || defEn) : (s.body_en || s.body_ar || defEn);
  };
  const cImg = (key, defSrc) => cms[key]?.image_url || defSrc;

  const paras = (text) => text?.split("\n\n").filter(Boolean).map((p, i) => <p key={i} className="gal-body-text">{p}</p>);

  // Build gallery/space/artist lists from CMS or defaults
  const getListItems = (prefix, defaults) => {
    const items = Object.values(cms).filter((s) => s.section_key.startsWith(prefix + "_")).sort((a, b) => a.sort_order - b.sort_order);
    if (items.length > 0) return items.map((s) => ({
      key:       s.section_key,
      name:      isAr ? (s.title_ar    || s.title_en)    : (s.title_en    || s.title_ar),
      desc:      isAr ? (s.body_ar     || s.body_en)     : (s.body_en     || s.body_ar),
      img:       s.image_url,
      url:       s.link_url,
      tag:       isAr ? (s.link_label_ar || s.link_label_en) : (s.link_label_en || s.link_label_ar),
      contact:   s.image_caption,
      clickable: s.image_clickable,
    }));
    // Use bilingual default fields
    return defaults.map((d) => ({
      ...d,
      name: isAr ? (d.name_ar || d.name) : d.name,
      desc: isAr ? (d.desc_ar || d.desc) : d.desc,
      tag:  isAr ? (d.tag_ar  || d.tag)  : d.tag,
    }));
  };

  const galleries  = getListItems("gallery", DEFAULT_GALLERIES);
  const spaces     = getListItems("space",   DEFAULT_SPACES);
  const artists    = getListItems("artist",  DEFAULT_ARTISTS);

  // Art links from CMS (link_* items) or defaults
  const linkItems = (() => {
    const items = Object.values(cms).filter((s) => s.section_key.startsWith("link_")).sort((a, b) => a.sort_order - b.sort_order);
    if (items.length > 0) return items.map((s) => ({
      name: isAr ? (s.title_ar || s.title_en) : (s.title_en || s.title_ar),
      desc: isAr ? (s.body_ar  || s.body_en)  : (s.body_en  || s.body_ar),
      url:  s.link_url || "#",
    }));
    return DEFAULT_LINKS.map((l) => ({
      name: isAr ? (l.name_ar || l.name) : l.name,
      desc: isAr ? (l.desc_ar || l.desc) : l.desc,
      url:  l.url,
    }));
  })();

  // Extra sections not handled above
  const HANDLED = new Set(["hero", "street_art", "war_card", "galleries_intro", "spaces_intro", "artists_intro", "links_intro"]);
  const extraSections = Object.values(cms)
    .filter((s) => !HANDLED.has(s.section_key) && !s.section_key.startsWith("gallery_") && !s.section_key.startsWith("space_") && !s.section_key.startsWith("artist_") && !s.section_key.startsWith("link_"))
    .sort((a, b) => a.sort_order - b.sort_order);

  return (
    <div className="gal-page" dir={isAr ? "rtl" : "ltr"}>

      {lightbox && <Lightbox src={lightbox} onClose={() => setLightbox(null)} />}

      {/* ── Page Hero ─────────────────────────────────────────────────────── */}
      <header className="gal-hero">
        <div className="gal-hero-inner">
          <p className="gal-eyebrow">{isAr ? "الفن والثورة" : "Art & Revolution"}</p>
          <h1 className="gal-hero-title">
            {cTitle("hero",
              "How Street Art Changed\nthe Protests in Sudan",
              "كيف غيّر فن الشارع\nالاحتجاجات في السودان"
            )}
          </h1>
          <p className="gal-hero-subtitle">
            {cBody("hero",
              "The once-grey walls near Khartoum's army headquarters filled with clenched fists, victory signs, and portraits of the revolution — art becoming the language of a people's uprising.",
              "امتلأت الجدران الرمادية بالقبضات المرفوعة وإشارات النصر — أصبح الفن لغة انتفاضة شعب."
            )}
          </p>
        </div>
        <div className="gal-hero-img-wrap">
          <img
            src={cImg("hero", STREET_IMG)}
            alt={isAr ? "فن الشارع - ثورة السودان" : "Street art Sudan revolution"}
            className="gal-hero-img"
            onClick={cms.hero?.image_clickable ? () => openLb(cImg("hero", STREET_IMG)) : undefined}
            style={{ cursor: cms.hero?.image_clickable ? "zoom-in" : "default" }}
            onError={(e) => { e.target.style.display = "none"; }}
          />
          <div className="gal-hero-img-overlay" />
        </div>
      </header>

      {/* ── Street Art Editorial ──────────────────────────────────────────── */}
      <section className="gal-section">
        <div className="gal-editorial-grid">
          <div className="gal-editorial-text">
            <p className="gal-eyebrow">{isAr ? "21 أبريل 2019 · فن الشارع" : "21 April 2019 · Street Art"}</p>
            <h2 className="gal-section-title">
              {cTitle("street_art", "Street Art in Sudan", "فن الشارع في السودان")}
            </h2>
            {paras(cBody("street_art",
              "In December of 2018, a series of anti-government protests broke out across Sudan, leading to the ousting of former president Omar Al-Bashir by April 2019. As the nine-month political revolution took form, a parallel movement in street art was born — today, reminders of the revolution colour the built fabric of the country.\n\nSudanese graffiti artist Amir Saleh and his team painted murals during protests near army headquarters in Khartoum. For years such artwork remained underground amid censorship imposed by security agents who considered it anti-establishment. But everything changed on April 6, when thousands of protesters broke through security cordons and massed outside army headquarters.\n\nThe walls that frame Sudan's streets remain painted with words and portraits that tell tales of the revolution, blending urban art with the country's spatial forms.",
              "في ديسمبر 2018، اندلعت موجة من الاحتجاجات المناهضة للحكومة في جميع أنحاء السودان.\n\nرسم الفنان السوداني أمير صالح وفريقه جداريات خلال الاحتجاجات.\n\nتظل جدران شوارع السودان مزيّنة بكلمات وصور تحكي حكايات الثورة."
            ))}
          </div>
          <aside className="gal-editorial-aside">
            <div className="gal-war-card">
              <div className="gal-war-card-bar" />
              <h3 className="gal-war-card-title">
                {cTitle("war_card", "Art Activities During War", "الفن في زمن الحرب")}
              </h3>
              {paras(cBody("war_card",
                "On April 15th, 2023, war broke out in Sudan. The area of Downtown Khartoum and Khartoum 2 — the artistic neighbourhood — was heavily destroyed by airstrikes. Numerous artists were trapped in those places, which once were full of art galleries, music, and painting studios.\n\nWarlords have come to realize the impactful role of art in enlightening people. Consequently, they have chosen to deplete all art resources — destroying galleries and exhibition halls that once thrived with artistic expression.",
                "في 15 أبريل 2023، اندلعت الحرب في السودان. تعرّض حي وسط الخرطوم — الحي الفني — لدمار شديد.\n\nأدرك أمراء الحرب الدور المؤثر للفن، فاختاروا تدمير المعارض وقاعات الفنون."
              ))}
            </div>
          </aside>
        </div>
      </section>

      {/* ── Art Galleries ─────────────────────────────────────────────────── */}
      <section className="gal-galleries-section">
        <div className="gal-galleries-inner">
          <div className="gal-galleries-header">
            <div>
              <p className="gal-eyebrow">{isAr ? "مشهد الخرطوم الفني" : "Khartoum Art Scene"}</p>
              <h2 className="gal-section-title">
                {cTitle("galleries_intro", "Art Galleries & Spaces in Sudan", "صالات ومساحات الفن في السودان")}
              </h2>
              <p className="gal-galleries-intro">
                {cBody("galleries_intro",
                  "Although there aren't national art galleries or cultural centres, Sudan's vibrant art scene has established remarkable private galleries.",
                  "على الرغم من غياب معارض الفنون الوطنية، أسّس المشهد الفني السوداني النابض بالحياة معارض خاصة رائعة."
                )}
              </p>
            </div>
          </div>
          <div className="gal-cards-grid">
            {galleries.map((g) => (
              <div key={g.key || g.name} className="gal-card">
                <div className="gal-card-img-wrap">
                  <ImgWithFallback
                    src={g.img} alt={g.name} className="gal-card-img" fallbackText={g.name?.[0]}
                    onClick={g.clickable ? () => openLb(g.img) : undefined}
                  />
                  {g.tag && <span className="gal-card-tag">{g.tag}</span>}
                </div>
                <div className="gal-card-body">
                  <h3 className="gal-card-name">{g.name}</h3>
                  <p className="gal-card-desc">{g.desc}</p>
                  <div className="gal-card-meta">
                    {g.contact && <span>{g.contact}</span>}
                    {g.instagram && <a href={`https://instagram.com/${g.instagram.replace("@","")}`} target="_blank" rel="noopener noreferrer">{g.instagram}</a>}
                    {g.url && <a href={g.url} target="_blank" rel="noopener noreferrer">{isAr ? "زيارة الموقع" : "Visit Website"}</a>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Art Spaces ────────────────────────────────────────────────────── */}
      <section className="gal-section">
        <h2 className="gal-section-title">
          {cTitle("spaces_intro", "Art Cafés & Creative Spaces", "المقاهي والمساحات الإبداعية")}
        </h2>
        <div className="gal-spaces-grid">
          {spaces.map((s) => (
            <div key={s.key || s.name} className="gal-space-card">
              <div className="gal-space-img-wrap">
                <ImgWithFallback src={s.img} alt={s.name} className="gal-space-img" fallbackText={s.name?.[0]}
                  onClick={s.clickable ? () => openLb(s.img) : undefined} />
              </div>
              <div className="gal-space-body">
                <h3 className="gal-space-name">{s.name}</h3>
                <p className="gal-space-desc">{s.desc}</p>
                {(s.credit || s.contact) && (
                  <p className="gal-space-credit">{s.credit ? `Photo: ${s.credit}` : s.contact}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Globally Known Artists ────────────────────────────────────────── */}
      <section className="gal-artists-section">
        <div className="gal-artists-inner">
          <div className="gal-artists-header">
            <p className="gal-eyebrow">{isAr ? "أساتذة الفن السوداني" : "Masters of Sudanese Art"}</p>
            <h2 className="gal-section-title">
              {cTitle("artists_intro", "Globally Known Sudanese Artists", "فنانون سودانيون معروفون عالمياً")}
            </h2>
            <p className="gal-body-text" style={{ maxWidth: 580 }}>
              {cBody("artists_intro",
                "These artists stand as prominent Sudanese modernisers on the global stage, redefining Sudan's cultural landscape by bridging heritage and modernity.",
                "يقف هؤلاء الفنانون كمحدّثين سودانيين بارزين على الصعيد العالمي، يعيدون تعريف المشهد الثقافي السوداني."
              )}
            </p>
          </div>
          <div className="gal-artists-grid">
            {artists.map((a) => (
              <div key={a.key || a.name} className="gal-artist-card">
                <div className="gal-artist-img-wrap">
                  <ImgWithFallback src={a.img} alt={a.name} className="gal-artist-img" fallbackText={a.name?.[0]}
                    onClick={a.clickable ? () => openLb(a.img) : undefined} />
                </div>
                <div className="gal-artist-body">
                  <p className="gal-artist-born">{a.born || a.contact}</p>
                  <h3 className="gal-artist-name">{a.name}</h3>
                  <p className="gal-artist-desc">{a.desc}</p>
                  {a.url && (
                    <a href={a.url} target={a.url?.startsWith("http") ? "_blank" : "_self"}
                      rel="noopener noreferrer" className="gal-artist-link">
                      {isAr ? "اعرف أكثر →" : "Learn More →"}
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="gal-artists-cta">
            <a href="/ArtistsList" className="spar-btn spar-btn-primary">
              {isAr ? "استعرض جميع الفنانين" : "Explore All Artists"}
            </a>
          </div>
        </div>
      </section>

      {/* ── Art Links ─────────────────────────────────────────────────────── */}
      <section className="gal-section gal-links-section">
        <h2 className="gal-section-title">
          {cTitle("links_intro", "Art Resources & Platforms", "مصادر ومنصات فنية")}
        </h2>
        <div className="gal-links-grid">
          {linkItems.map((link) => (
            <a key={link.name} href={link.url} target="_blank" rel="noopener noreferrer" className="gal-link-card">
              <h3 className="gal-link-name">{link.name}</h3>
              <p className="gal-link-desc">{link.desc}</p>
              <span className="gal-link-arrow">→</span>
            </a>
          ))}
        </div>
      </section>

      {/* ── Extra CMS sections ─────────────────────────────────────────────── */}
      {extraSections.map((s) => {
        const title    = isAr ? (s.title_ar || s.title_en) : (s.title_en || s.title_ar);
        const body     = isAr ? (s.body_ar  || s.body_en)  : (s.body_en  || s.body_ar);
        const btnLabel = isAr ? (s.link_label_ar || s.link_label_en) : (s.link_label_en || s.link_label_ar);
        return (
          <section key={s.id} className="gal-section">
            {title && <h2 className="gal-section-title">{title}</h2>}
            {s.image_url && (
              <img src={s.image_url} alt={title || ""} style={{ width: "100%", borderRadius: 12, marginBottom: 20, objectFit: "cover" }}
                onClick={s.image_clickable ? () => openLb(s.image_url) : undefined}
                onError={(e) => { e.target.style.display = "none"; }}
                style={{ cursor: s.image_clickable ? "zoom-in" : "default", width: "100%", borderRadius: 12, marginBottom: 20 }} />
            )}
            {paras(body)}
            {s.link_url && (
              <a href={s.link_url} target={s.link_target || "_self"}
                 rel={s.link_target === "_blank" ? "noopener noreferrer" : undefined}
                 className="spar-btn spar-btn-primary" style={{ marginTop: 12 }}>
                {btnLabel || (isAr ? "اقرأ المزيد" : "Learn More")}
              </a>
            )}
          </section>
        );
      })}

    </div>
  );
}
